module.exports = __webpack_public_path__ + "static/img/logo_white.1e51869.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/logo_white.png
// module id = DUCb
// module chunks = 1